import { es } from '@/i18n/es';
import { useUiStore } from '@/store/uiStore';
import { persistPreference } from '@/store/sessionStore';
import type { ThemeMode } from '@/types';

const ORDER: ThemeMode[] = ['system', 'light', 'dark'];

/** Cicla sistema → claro → oscuro. El estado se anuncia por texto, no por ícono. */
export function ThemeToggle({ className }: { className?: string }) {
  const theme = useUiStore((s) => s.theme);
  const setTheme = useUiStore((s) => s.setTheme);

  function cycle() {
    const next = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length] as ThemeMode;
    setTheme(next);
    void persistPreference({ theme: next });
  }

  const label =
    theme === 'system' ? es.theme.system : theme === 'light' ? es.theme.light : es.theme.dark;

  return (
    <button
      type="button"
      onClick={cycle}
      title={`${es.theme.toggle}: ${label}`}
      aria-label={`${es.theme.toggle}. Actual: ${label}`}
      className={`rounded-pill p-2 text-muted transition-colors hover:bg-surface-alt hover:text-ink ${className ?? ''}`}
    >
      {theme === 'dark' ? <MoonIcon /> : theme === 'light' ? <SunIcon /> : <AutoIcon />}
    </button>
  );
}

function SunIcon() {
  return (
    <svg viewBox="0 0 20 20" className="h-5 w-5" aria-hidden="true" focusable="false">
      <circle cx="10" cy="10" r="3.6" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M10 2v1.8M10 16.2V18M18 10h-1.8M3.8 10H2m12.2-4.2-1.3 1.3M7.1 12.9l-1.3 1.3m8.4 0-1.3-1.3M7.1 7.1 5.8 5.8"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 20 20" className="h-5 w-5" aria-hidden="true" focusable="false">
      <path
        d="M16.5 12.4A7 7 0 0 1 7.6 3.5a7 7 0 1 0 8.9 8.9Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AutoIcon() {
  return (
    <svg viewBox="0 0 20 20" className="h-5 w-5" aria-hidden="true" focusable="false">
      <circle cx="10" cy="10" r="7" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M10 3a7 7 0 0 1 0 14V3Z" fill="currentColor" />
    </svg>
  );
}
